import { render } from "./BaseModal.vue?vue&type=template&id=773075cc&scoped=true"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"

import "./BaseModal.vue?vue&type=style&index=0&id=773075cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-773075cc"

export default script